import { isNullOrWhiteSpace } from "../utils/string-helper";

interface Config {
	appBaseUrl: string;
	apiBaseUrl: string;
	releaseTag?: string;
	commitHash?: string;
	authorityUrl: string;
	bffUrl: string;
	applicationInsightsKey: string;
	imageCdnUrl: string;
	cloudUrl: string;
}

const config: Config = {
	authorityUrl: import.meta.env.VITE_SSO_AUTHORITY_URL,
	appBaseUrl: import.meta.env.VITE_APP_BASE_URL,
	apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
	bffUrl: import.meta.env.VITE_BFF_URL,
	releaseTag: !isNullOrWhiteSpace(import.meta.env.VITE_RELEASE_TAG)
		? import.meta.env.VITE_RELEASE_TAG
		: undefined,
	commitHash: !isNullOrWhiteSpace(import.meta.env.VITE_COMMIT_HASH)
		? import.meta.env.VITE_COMMIT_HASH
		: undefined,
	applicationInsightsKey: import.meta.env.VITE_APPLICATION_INSIGHTS_KEY,
	imageCdnUrl: import.meta.env.VITE_IMAGE_STORAGE_URL,
	cloudUrl: import.meta.env.VITE_CLOUD_URL,
};

export default config;
